import { Grid } from "@mui/material";
import * as React from "react";
import { Create, required, SelectInput, TextInput } from "react-admin";
import { SimpleForm } from "src/enterprise/ra-rbac";
import { MakerFilterCreateComponent } from "./MakerFilterComponent";

export const MakerFilterCreate = () => (
  <Create component={MakerFilterCreateComponent}>
    <SimpleForm>
      <Grid container rowSpacing={1} columnSpacing={2}>
        <Grid item sm={12} md={6}>
          <TextInput source="code" validate={required()} />
        </Grid>
        <Grid item sm={12} md={6}>
          <TextInput source="name" validate={required()} />
        </Grid>
        <Grid item sm={12} md={6}>
          <SelectInput
            source="type"
            choices={[
              { id: "type", name: "Type" },
              { id: "region", name: "Region" },
            ]}
          />
        </Grid>
      </Grid>
    </SimpleForm>
  </Create>
);
